import { LocationQuery } from 'vue-router'

export default function stashNextRedirectURL(BASE_URL: string, query: LocationQuery): void {
  if (query) {
    sessionStorage.setItem('redirectToSharedUrlAfterLogin', JSON.stringify({ query, path: BASE_URL }))
  }
}
